import React from 'react';
import classnames from 'classnames';
import ListCard from './list-card';

const AdminListCard = (props) => {
  const { className, ...cardProps } = props;
  return (
    <ListCard
      className={classnames('admin-list-card', className)}
      {...cardProps}
    />
  );
};

AdminListCard.propTypes = {
  ...ListCard.propTypes,
};

export default AdminListCard;
